import React, { useState } from 'react';

import Link from 'next/link';

import HomeHeading from '@components/common/Heading/HomeHeading/HomeHeading';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import CallSupportModal from '@components/common/Modals/CallSupportModal/CallSupportModal';
import Text from '@components/common/Text/Text';
import SearchBar from '@components/lpc/Help-center/MainPage/SearchBar/SearchBar';
import ThematicsDetails from '@components/lpc/Help-center/ThematicsDetailsPage/ThematicsDetails';
import Layout from '@components/lpc/Layout/Layout';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './ThematicsDetailsPage.module.scss';

const ThematicsDetailsPage = () => {
    const { t } = useTranslateLpc('help-center');
    const [questionID, setQuestionID] = useState<number>(null);
    const [thematicID, setThematicID] = useState<number>(null);
    const [subThematicID, setSubThematicID] = useState<number>(null);
    const [showCallSupport, setShowCallSupport] = useState<boolean>(false);

    const onSelectQuestion = (question, thematic, subThematic) => {
        setQuestionID(question);
        setThematicID(thematic);
        setSubThematicID(subThematic);
    };
    return (
        <Layout isHomePage>
            <div className={css.thematics_details_container__title}>
                <HomeHeading title={t('details-page.title')} subtitle={t('details-page.subtitle')} />
                <div className={css.thematics_details_container__subtitle}>
                    <Text
                        variant={'body_02'}
                        color={'txt-primary'}
                        customClass={css.thematics_details_container__subtitle__subtitle_txt}
                    >
                        {t('details-page.paragraph-1')}
                    </Text>
                    <Text
                        variant={'body_02'}
                        color={'txt-primary'}
                        customClass={css.thematics_details_container__subtitle__subtitle_txt}
                    >
                        {t('details-page.paragraph-2')}
                    </Text>
                </div>
            </div>
            <div className={css.thematics_details_container__search_bar}>
                <SearchBar
                    onSelectQuestion={(question, thematic, subThematic) =>
                        onSelectQuestion(question, thematic, subThematic)
                    }
                />
            </div>
            <div className={css.thematics_details_container__details}>
                <ThematicsDetails questionID={questionID} thematicID={thematicID} subThematicID={subThematicID} />
            </div>
            <div className={css.thematics_details_container__call}>
                <Text
                    variant={'body_02'}
                    customClass={css.thematics_details_container__help_caption__title_caption}
                    color={'brand-primary'}
                >
                    {t('details-page.second-title')}
                </Text>
                <br />
                <Text
                    variant={'body_02'}
                    customClass={css.thematics_details_container__help_caption}
                    color={'txt-primary'}
                >
                    {t('details-page.subtitle-2')}
                    <Link
                        href={getRoute(ROUTE.LPC.HELP_CENTER.CONTACT)}
                        className={css.thematics_details_container__help_caption__txt_color}
                    >
                        {t('details-page.subtitle-3')}
                    </Link>
                </Text>
                <Text
                    variant={'body_02'}
                    customClass={css.thematics_details_container__help_caption}
                    color={'txt-primary'}
                >
                    {t('details-page.subtitle-4')}
                </Text>
                <div className={css.thematics_details_container__call__sub_call}>
                    <Text
                        variant={'body_02'}
                        color={'txt-secondary'}
                        customClass={css.thematics_details_container__call__sub_call__call_txt1}
                    >
                        {t('details-page.subtitle-5')}
                        <a
                            onClick={() => setShowCallSupport(true)}
                            className={css.thematics_details_container__call__sub_call__call_txt}
                        >
                            {t('details-page.subtitle-6')}
                        </a>
                    </Text>
                    <img
                        className={css.thematics_details_container__call__sub_call__call_icon}
                        src="/front-static/icons/action/telephone-receiver.png"
                        width={16}
                        height={18}
                        alt={'telephone...'}
                    />
                </div>
                {showCallSupport && (
                    <CallSupportModal isVisible={showCallSupport} onHide={() => setShowCallSupport(false)} />
                )}
            </div>
        </Layout>
    );
};

export default ThematicsDetailsPage;
